import CryptoJS from 'crypto-js';

export default {
  //随机生成指定数量的16进制key
  generatekey (num) {
    let library = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let key = "";
    for (var i = 0; i < num; i++) {
      let randomPoz = Math.floor(Math.random() * library.length);
      key += library.substring(randomPoz, randomPoz + 1);
    }
    return key;
  },
  encrypt (word) {
    var _word = CryptoJS.enc.Utf8.parse(word),
      _key = CryptoJS.enc.Utf8.parse("ihaierForTodoKey"),
      _iv = CryptoJS.enc.Utf8.parse("ihaierForTodo_Iv");
    var encrypted = CryptoJS.AES.encrypt(_word, _key, {
      iv: _iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  },
  //加密
  // encrypt(word, keyStr) {
  //     keyStr = keyStr ? keyStr : 'abcdsxyzhkj12345'; //判断是否存在ksy，不存在就用定义好的key
  //     var key = CryptoJS.enc.Utf8.parse(keyStr);
  //     var srcs = CryptoJS.enc.Utf8.parse(word);
  //     var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
  //     return encrypted.toString();
  // },
  //解密
  decrypt (word, keyStr) {
    keyStr = keyStr ? keyStr : 'abcdsxyzhkj12345';
    var key = CryptoJS.enc.Utf8.parse(keyStr);
    var decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  },
  decryptData(str, KEY, IV = '') {
    str = (str + '').replace(/\n*$/g, '').replace(/\n/g, ''); //增加这一行，将换行符替换为空
    var key = CryptoJS.enc.Utf8.parse(KEY);
    var iv = CryptoJS.enc.Utf8.parse(IV);
    var decrypt = CryptoJS.AES.decrypt(str, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
	  return decrypt.toString(CryptoJS.enc.Utf8);
  }
}